<template>
  <div id="app">

 <app-header ></app-header>
 <app-leftnav :info="info"  v-on:update_messages_data="updateMessages($event)"></app-leftnav>
 <app-content :messages="messages"></app-content>
  </div>
</template>

<script>
  import Header from './components/Header.vue'
  import Leftnav from './components/Leftnav.vue'
  import Content from './components/Content.vue'

  export default {
     data () {
    return {
      info: null,
      messages:'kjsdnhflhsdf'
    }},
        created() {},
        mounted () {
        axios
        .get('jsonmail.json')
        .then((response) => { this.info=response.data})},
        components: {
            appHeader: Header,
            appLeftnav: Leftnav,
            appContent: Content,
        },
        methods:{

          updateMessages : function (messages_info){

            this.messages=messages_info;
          }
        }
    }
</script>


